export default {
  // Theme
  darkMode: false,
  lang: 'en',
  activeLangMenu: false,

  // Location
  locationShared: false,
  userLat: null,
  userLng: null,
  showClinicsMap: true,

  // Appointment Modal
  selectedAppointment: null,
  showAppointmentModal: false,

  // Navigation
  activeTab: 'appointments',
  activeAiTool: 'assistant',
  activePatientSection: 'overview',

  // Booking
  activeBookingStep: 1,
  selectedClinic: null,
  selectedClinicId: null,
  selectedService: null,
  selectedDate: null,
  selectedTime: null,
  clinicFilter: '',

  // Patient
  selectedTooth: null,

  // Chart
  selectedSurface: null,
  chartMode: 'odontogram',
  toothData: {},

  // Perio
  currentExamId: 'exam-2024-03',
  selectedExamIds: ['exam-2024-03', 'exam-2023-09'],
  entryMode: 'probing',
  perioData: {},

  // Treatment Plan
  activePlanId: 'plan-a',
  showAlternative: false,
  treatmentPhases: [],

  // Clinical Notes
  selectedNoteDate: null,
  editingNoteId: null,
  templateType: null,
  clinicalNotes: [],

  // Scheduling
  viewMode: 'week',
  currentDate: '2026-03-18',
  selectedOperatory: 'all',
  selectedProvider: 'all',

  // Billing
  billingTab: 'claims',
  selectedClaimId: null,

  // Prescriptions
  activeRxTab: 'active',
  editingRxId: null,
  showInteractions: false,

  // Lab Cases
  labViewMode: 'pipeline',
  selectedCaseId: null,

  // Referrals
  referralDirection: 'all',
  selectedReferralId: null,

  // Reports
  reportType: 'production',
  reportDateRange: 'this-month',
  reportProviderId: 'all',

  // Medical History
  medHistorySection: 'timeline',
  medHistoryPatientId: 'P-1042',

  // Enterprise
  enterprisePanel: 'rbac',

  // Integrations
  integrationCategory: 'all',
  selectedIntegration: null,

  // AI Modal
  showAiModal: false,
  aiModalThread: [],
  aiModalLoading: false,

  // AI
  messages: [
    { role: 'assistant', content: 'გამარჯობა! I am your dental clinical assistant. I can help with treatment planning, clinical notes, drug interactions, and patient communication. How can I help?' },
    { role: 'user', content: 'Patient has periapical lesion on tooth #14 with chronic pain. What treatment options should I consider?' },
    { role: 'assistant', content: 'For a periapical lesion on tooth #14 with chronic pain, consider:\n\n1. **Root Canal Treatment (RCT)** — First-line treatment. Clean, shape, and obturate the canal system. Success rate ~85-95%.\n\n2. **Apicoectomy** — If RCT fails or retreatment is not feasible. Surgical removal of the apex + retrograde filling.\n\n3. **Extraction + Implant** — If tooth is non-restorable (extensive decay, fracture, poor prognosis).\n\n**Recommended diagnostics:** Periapical radiograph, vitality test (cold/EPT), probing depths.\n\n**Drug consideration:** Prescribe Amoxicillin 500mg TID for 7 days if acute infection present. Check penicillin allergy first.' }
  ],
  isTyping: false,

  // Waitlist
  waitlistEmail: '',

  // Clinics - fetched from Supabase
  clinics: [],
  clinicsLoaded: false,
  clinicsVisible: 24,

  // Services
  services: [
    { name: 'Implant', price: '₾300+', emoji: '🦷' },
    { name: 'Whitening', price: '₾120', emoji: '✨' },
    { name: 'Checkup', price: '₾30', emoji: '🔍' },
    { name: 'Orthodontics', price: '₾1,200', emoji: '🦿' },
    { name: 'Surgery', price: '₾400', emoji: '🏥' }
  ],
  dates: [
    { label: 'Mon 19', value: '2026-03-19' },
    { label: 'Tue 20', value: '2026-03-20' },
    { label: 'Wed 21', value: '2026-03-21' },
    { label: 'Thu 22', value: '2026-03-22' },
    { label: 'Fri 23', value: '2026-03-23' },
    { label: 'Sat 24', value: '2026-03-24' },
    { label: 'Sun 25', value: '2026-03-25' }
  ],
  times: [
    { label: '09:00', period: 'Morning' },
    { label: '10:00', period: 'Morning' },
    { label: '11:00', period: 'Morning' },
    { label: '14:00', period: 'Afternoon' },
    { label: '15:00', period: 'Afternoon' },
    { label: '17:00', period: 'Evening' }
  ],

  // Dashboard data
  appointments: [
    { patient: 'Giorgi Beridze', time: '09:00', service: 'Checkup', doctor: 'Dr. Lomidze', status: 'Confirmed' },
    { patient: 'Nino Kapanadze', time: '10:30', service: 'Whitening', doctor: 'Dr. Kvaratskhelia', status: 'Pending' },
    { patient: 'Davit Gelashvili', time: '11:00', service: 'Implant Phase 2', doctor: 'Dr. Lomidze', status: 'Confirmed' },
    { patient: 'Mariam Tsiklauri', time: '14:00', service: 'Orthodontics', doctor: 'Dr. Beridze', status: 'Confirmed' },
    { patient: 'Ana Javakhishvili', time: '15:30', service: 'Root Canal', doctor: 'Dr. Lomidze', status: 'Pending' },
    { patient: 'Luka Mchedlishvili', time: '17:00', service: 'Extraction', doctor: 'Dr. Kvaratskhelia', status: 'Cancelled' }
  ],
  patients: [
    { name: 'Giorgi Beridze', age: 34, lastVisit: 'Mar 10', nextAppt: 'Mar 19', totalVisits: 12, phone: '+995 555 11 22 33' },
    { name: 'Nino Kapanadze', age: 28, lastVisit: 'Feb 28', nextAppt: 'Mar 20', totalVisits: 8, phone: '+995 599 44 55 66' },
    { name: 'Davit Gelashvili', age: 45, lastVisit: 'Mar 5', nextAppt: 'Mar 22', totalVisits: 23, phone: '+995 577 77 88 99' },
    { name: 'Mariam Tsiklauri', age: 31, lastVisit: 'Mar 12', nextAppt: 'Mar 25', totalVisits: 6, phone: '+995 555 22 33 44' },
    { name: 'Ana Javakhishvili', age: 52, lastVisit: 'Mar 8', nextAppt: 'Mar 21', totalVisits: 18, phone: '+995 599 88 77 66' },
    { name: 'Luka Mchedlishvili', age: 23, lastVisit: 'Mar 1', nextAppt: 'Apr 5', totalVisits: 3, phone: '+995 577 33 22 11' },
    { name: 'Tamara Lomidze', age: 67, lastVisit: 'Feb 15', nextAppt: 'Mar 28', totalVisits: 31, phone: '+995 322 55 44 33' },
    { name: 'Irakli Diasamidze', age: 41, lastVisit: 'Mar 14', nextAppt: 'Mar 30', totalVisits: 15, phone: '+995 555 99 88 77' }
  ],

  // Treatment plans
  treatmentPlans: [
    { tooth: 14, procedure: 'Root Canal Treatment', status: 'In Progress', price: '₾149', doctor: 'Dr. Lomidze' },
    { tooth: 36, procedure: 'Ceramic Crown', status: 'Planned', price: '₾600', doctor: 'Dr. Lomidze' },
    { tooth: 21, procedure: 'Composite Filling', status: 'Completed', price: '₾80', doctor: 'Dr. Kvaratskhelia' },
    { tooth: 46, procedure: 'Implant Placement', status: 'Planned', price: '₾1,200', doctor: 'Dr. Beridze' }
  ],

  // Invoices
  invoices: [
    { number: 'INV-001', patient: 'Giorgi Beridze', service: 'Checkup + X-ray', amount: '₾80', status: 'Paid' },
    { number: 'INV-002', patient: 'Nino Kapanadze', service: 'Whitening', amount: '₾120', status: 'Pending' },
    { number: 'INV-003', patient: 'Davit Gelashvili', service: 'Implant Phase 1', amount: '₾300+', status: 'Paid' },
    { number: 'INV-004', patient: 'Ana Javakhishvili', service: 'Root Canal', amount: '₾149', status: 'Overdue' }
  ]
}
